/* eslint-disable eqeqeq */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DefaultThemesV2 } from '../../stylesheets/themes/SCDefaultThemes.style';
import _isEqual from 'lodash/isEqual';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import Select from '@Atoms/Select';
import { CourseSelectWrap } from './CourseSelect.style';
import { retrieveCachedCourseAndSection } from '../../utils/cacheCourseAndSection';

class CourseSelect extends PureComponent {
  componentDidMount() {
    const { courseId, courseList, selectedCourse } = this.props;
    if (selectedCourse || courseList.length !== 0) {
      this.selectFirstCourse();
    }

    if (selectedCourse || courseId !== null) {
      this.getAllSectionByCourse(courseId || selectedCourse);
    }
  }

  componentDidUpdate(prevProps) {
    const { courseId, courseList } = this.props;
    const { courseId: prevCourseId, courseList: prevCourseList } = prevProps;

    if (!_isEqual(courseId, prevCourseId) && _isNil(courseId)) {
      this.getAllSectionByCourse(courseId);
    }

    if (
      !_isEqual(prevCourseList, courseList) &&
      _isNil(courseId) &&
      courseList.length !== 0
    ) {
      this.selectFirstCourse();
    }
  }

  getAllSectionByCourse = (courseId) => {
    const { getAllSectionByCourse, sectionStudentFilterAddAllOrCancel } = this.props;

    getAllSectionByCourse(courseId);
    sectionStudentFilterAddAllOrCancel([]);
  };

  selectCourseId = (courseId) => {
    const { history, pathName, selectCourse } = this.props;
    const course = this.props.courseList.find((c) => c.id == courseId);
    const { has_exam } = course;
    selectCourse(courseId);

    const filteredCourses = this.props.coursesById[courseId].sections.filter(
      (item) => new Date(item.end_date).getTime() >= new Date().getTime(),
    );

    if (pathName.startsWith('/coauthor')) {
      history.push(`${pathName}/${courseId}`);
    } else if (!/^\/dashboard/g.test(pathName) && (filteredCourses.length === 0 || !has_exam)) {
      history.replace(`/dashboard/course/${courseId}`);
    } else {
      history.push(`${pathName}/${courseId}`);
    }
  };

  selectFirstCourse() {
    const {
      courseList,
      history,
      pathName,
      selectedCourse,
      selectCourse,
      courseId: selectedCourseId,
    } = this.props;

    const { cachedCourseId, cachedSectionId } = retrieveCachedCourseAndSection();
    if (!courseList.length) {
      return;
    }
    if (courseList.find((course) => course.id == selectedCourseId)) {
      selectCourse(selectedCourseId);
      return;
    }
    if (!courseList.find((course) => course.id == cachedCourseId || course.id == selectedCourseId)) {
      selectCourse(courseList?.[0]?.id);
      history.push(`${pathName}/${courseList?.[0]?.id}`);
      return;
    }
    if (
      (cachedCourseId || (cachedCourseId && cachedSectionId)) &&
      pathName === '/dashboard/course'
    ) {
      history.push(
        `${pathName}/${cachedCourseId}${cachedSectionId && `/section/${cachedSectionId}`
        }`,
      );
      selectCourse(cachedCourseId);
      return;
    }

    if (selectedCourseId && selectedCourseId !== null) {
      selectCourse(selectedCourseId);
      return;
    }

    const firstItem =
      courseList.find((course) => course.section && course.section.length) ||
      courseList[0];
    const courseId = selectedCourse || _get(firstItem, 'id');

    history.push(`${pathName}/${courseId}`);
    selectCourse(courseId);
  }

  render() {
    const {
      isLoadingCourses = false,
      courseList = [],
      courseId,
      selectedCourse,
    } = this.props;
    const currentCourse = courseList.find(
      (course) => course.id == courseId || course.id == selectedCourse,
    );;

    return (
      <CourseSelectWrap>
        {isLoadingCourses ? (
          <span>Loading</span>
        ) : (
          <Select
            fullWidth
            variant='standard'
            sx={{
              marginTop: '0px',
            }}
            selectSx={{
              fontSize: '15px',
              marginTop: '4px',
              'svg': {
                fill: "white",
                stroke: DefaultThemesV2.colorStyled.ColorBgDefault
              }
            }}
            defaultValue={currentCourse?.id}
            onChangeHandler={this.selectCourseId}
            className="course-select-container"
            id="course-select"
            list={courseList.map((course) => ({
              label: course.name,
              value: course.id,
            }))}
            displayEmpty
            label='Course'
          />
        )}
      </CourseSelectWrap>
    );
  }
}

CourseSelect.propTypes = {
  history: PropTypes.any,
  isLoadingCourses: PropTypes.bool,
  courseId: PropTypes.any,
  courseList: PropTypes.array,
  getAllSectionByCourse: PropTypes.func,
  pathName: PropTypes.string,
  selectedCourse: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sectionStudentFilterAddAllOrCancel: PropTypes.func,
  selectCourse: PropTypes.func.isRequired,
};

export default CourseSelect;
